import { StyleSheet } from "react-native";
import colors from "./variables";

export default StyleSheet.create({
  container: {
    padding: 20,
    flex: 1,
    backgroundColor: colors.primary,
  },
  formContainer: {
    paddingVertical: 16,
    paddingHorizontal: 20,
    backgroundColor: "white",
    borderBottomColor: colors.verylightgray,
    borderBottomWidth: 1,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,

    elevation: 5,
  },
  formLabel: {
    color: colors.primary,
    marginBottom: 4,
    fontFamily: "Raleway_700Bold",
  },
  oneAddressContainer: {
    marginVertical: 8,
    paddingHorizontal: 10,
    paddingVertical: 8,
    borderColor: colors.lightgray,
    borderWidth: 1,
    borderRadius: 5,
  },
  oneAddressLabel: {
    fontSize: 14,
    color: "white",
    marginLeft: 8,
    fontFamily: "Raleway_400Regular",
  },
  oneAddressText: {
    color: colors.primary,
    backgroundColor: colors.verylightgray,
    borderRadius: 5,
    padding: 16,
    marginTop: 10,
    fontFamily: "Raleway_700Bold",
  },
  inputPlace: {
    backgroundColor: "white",
    borderColor: colors.lightgray,
    borderWidth: 1,
    borderRadius: 33,
    marginTop: 4,
    padding: 10,
    marginBottom: 16,
    color: colors.primary,
    fontSize: 14,
    fontFamily: "Raleway_400Regular",
  },
  inputPlaceContainer: {
    backgroundColor: "white",
    borderColor: colors.lightgray,
    borderWidth: 1,
    borderRadius: 33,
    marginTop: 4,
    padding: 10,
    marginBottom: 16,
  },
  inputPlaceText: {
    color: colors.primary,
    fontSize: 16,
    fontFamily: "Raleway_600SemiBold",
  },
  placeResultContainer: {
    backgroundColor: colors.verylightgray,
    borderRadius: 5,
    marginVertical: 4,
    paddingVertical: 6,
    paddingHorizontal: 10,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 1,
    },
    shadowOpacity: 0.22,
    shadowRadius: 2.22,

    elevation: 3,
  },
  placeResultName: {
    color: colors.primary,
    fontSize: 15,
    fontFamily: "Raleway_700Bold",
    marginBottom: 4,
  },
  placeResultAddress: {
    color: colors.primary,
    fontSize: 12,
    fontFamily: "Raleway_400Regular",
  },
});
